import { Routes } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { HomeEffects, homeFeatureKey, reducer } from './store/home';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/about' },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
    providers: [
      provideState(homeFeatureKey, reducer),
      provideEffects([HomeEffects]),
    ],
  },
  {
    path: 'stats',
    loadChildren: () =>
      import('./pages/stats/stats.routes').then((m) => m.STATS_ROUTES),
  },
  {
    path: 'add-channel',
    loadComponent: () =>
      import('./pages/add-channel/add-channel.component').then(
        (m) => m.AddChannelComponent,
      ),
  },
];
